import type { SupSingleVaultV3 } from "@/types";
import React from "react";

import ChipVaultAssets from "@/components/Ui/Chip/Vault/Assets";

interface GridCellTokenProps {
  singleVault: SupSingleVaultV3;
  showChain?: boolean;
}

export default function GridCellToken({ singleVault, showChain }: GridCellTokenProps) {
  return <ChipVaultAssets assets={singleVault.assets} vaultId={singleVault.id} chain={singleVault.chain} useSmall showChain={showChain} />;
}
